import React, { useState, useEffect, useCallback } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'components/inputs/Button';
import { Formik, Form, getIn } from 'formik';
// import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { ADD_COCAPEX_LIST_ITEM, FETCH_COCAPEX_LIST, UPDATE_COCAPEX_LIST_ITEM } from 'actions/coCapex';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import { t } from 'i18next';
import Card from 'components/inputs/Card';
import { FiEdit2 } from 'react-icons/fi';
import TextInput from 'components/inputs/Input';
import { MdClose } from 'react-icons/md';
import _ from 'lodash';
import { cookie } from 'utils/cookies/cookies';
import axios from 'axios';
import { toast } from 'react-toastify';
import queryString from 'query-string';
import { FaCloudUploadAlt } from 'react-icons/fa';
import { Form as BootstrapForm } from 'react-bootstrap';
import { CREATE_STATUS_CODE } from 'components/common/constant';
import { FETCH_VEHICLE_MAKE } from 'actions/vehicleMake';
import Select from 'components/inputs/Select';
import * as Yup from 'yup';

const CoCapexList = () => {
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const token = cookie.get('token');
  const coCapexData = useSelector((state) => state?.coCapexListReducer?.coCapexData);
  const makeList = useSelector((state) => state.vehicleMake.vehicleMakes);
  const [showModal, setShowModal] = useState(false);
  const [showLightIcon, setShowLightIcon] = useState('');
  const [showDarkIcon, setShowDarkIcon] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    dispatch({ type: FETCH_COCAPEX_LIST.REQUEST });
  }, [dispatch]);

  const handleOpenModal = (item) => {
    setIsEdit(true);
    setSelectedItem(item);
    setShowModal(true);
    setShowLightIcon(item.light_logo_url);
    setShowDarkIcon(item.dark_logo_url);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsEdit(false);
    setSelectedItem(null);
    setShowLightIcon('');
    setShowDarkIcon('');
  };

  useEffect(() => {
    if (!showModal) {
      setIsEdit(false);
      setSelectedItem(null);
      setShowLightIcon('');
      setShowDarkIcon('');
    }
  }, [showModal]);

  const addHandler = () => {
    setIsEdit(false);
    setSelectedItem(null);
    setShowLightIcon('');
    setShowDarkIcon('');
    setShowModal(true);
  };

  const handleUploadFile = async (url, imageData, type) => {
    const fileType = _.get(imageData, 'type', '');

    try {
      const response = await axios({
        method: 'put',
        headers: {
          'Content-Type': fileType,
          'Content-Encoding': 'base64',
        },
        url: url,
        data: imageData,
      });

      if (response.status === 200) {
        const imgUrlData = queryString.parseUrl(url);
        const imageUrl = imgUrlData.url;

        // Update state based on logo type
        if (type === 'light') {
          setShowLightIcon(imageUrl);
        } else if (type === 'dark') {
          setShowDarkIcon(imageUrl);
        }

        return imageUrl;
      } else {
        toast.error('Failed to upload image');
        return null;
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      toast.error('Error uploading image');
      return null;
    }
  };

  // Usage in handleImage:
  const handleImage = async (image, type) => {
    const fileName = _.get(image, 'name', '');

    try {
      const response = await axios({
        method: 'get',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        url: process.env.REACT_APP_API_URL + `/util/fileupload?name=${fileName}`,
      });

      if (response.status === 201) {
        const signedRequest = _.get(response, 'data.signedRequest', '');
        return handleUploadFile(signedRequest, image, type);
      } else {
        toast.error(response.data.message);
        return null;
      }
    } catch (error) {
      console.error('Error getting signed URL:', error);
      toast.error('Error uploading image');
      return null;
    }
  };

  const addCoCapexItem = useCallback((data) => {
    dispatch({
      type: ADD_COCAPEX_LIST_ITEM.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          window.location.reload();
        }
      },
    });
  }, []);

  const getMake = useCallback(() => {
    dispatch({
      type: FETCH_VEHICLE_MAKE.REQUEST,
      payload: { limit: 1000 }, // Set high limit to get all data
    });
  }, [dispatch]);

  // Update useEffect
  useEffect(() => {
    getMake();
  }, [getMake]);

  const editCoCapex = useCallback(
    (data) => {
      dispatch({
        type: UPDATE_COCAPEX_LIST_ITEM.REQUEST,
        payload: data,
        cb: (res) => {
          if (_.get(res, 'status') === 200) {
            window.location.reload();
          }
        },
      });
    },
    [dispatch]
  );

  const ValidationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required').max(50, 'Name must not exceed 50 characters'),
    evmasterdata_id: Yup.string().required('EV Master Data is required'),
    light_logo_url: Yup.mixed().test('required', 'Light logo is required', function (value) {
      return value || this.parent.lightLogoFile;
    }),
    dark_logo_url: Yup.mixed().test('required', 'Dark logo is required', function (value) {
      return value || this.parent.darkLogoFile;
    }),
    min_price_per_unit: Yup.number()
    .required('Minimum Price Per Unit is required')
    .positive('Minimum Price Per Unit must be a positive number'),
  discount_value: Yup.number()
    .required('Discount Value is required')
    .min(0, 'Discount Value must be at least 0')
    .max(100, 'Discount Value cannot exceed 100'),
  });

  return (
    <>
      <LayoutContainer>
        <AdminHeader title={t('coCapex.title')} />
        <div className="page-content-wrapper scrollable">
          <Card>
            <div>
              <div className="co-capex-add">
                <button onClick={addHandler}>Add</button>
              </div>

              <div className="co-capex-list">
                <table>
                  <thead>
                    <tr>
                      <th>{t('coCapex.name')}</th>
                      <th>{t('coCapex.evmaster_id')}</th>
                      <th>{t('coCapex.light_image')}</th>
                      <th>{t('coCapex.dark_image')}</th>
                      <th>{t('coCapex.action')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {coCapexData?.map((item, index) => (
                      <tr key={index}>
                        <td>{item?.name}</td>
                        <td>{item?.evmasterdata_id?.name}</td>
                        <td>
                          <img src={item?.light_logo_url} alt="light_logo_url" className="co-capex-image" />
                        </td>
                        <td>
                          <img src={item?.dark_logo_url} alt="dark_logo_url" className="co-capex-image" />
                        </td>
                        <td>
                          <FiEdit2 size={20} color="#4975F2" cursor={'pointer'} onClick={() => handleOpenModal(item)} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </Card>
        </div>
      </LayoutContainer>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Header closeButton={false}>
          <div className="co-capex-modal-header">
            <Modal.Title className="co-capex-modal">{isEdit ? t('coCapex.editTitle') : t('coCapex.addTitle')}</Modal.Title>

            <button onClick={handleCloseModal}>
              <MdClose />
            </button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              name: isEdit ? selectedItem?.name : '',
              lightLogoFile: null,
              darkLogoFile: null,
              light_logo_url: isEdit ? selectedItem?.light_logo_url : '',
              dark_logo_url: isEdit ? selectedItem?.dark_logo_url : '',
              evmasterdata_id: isEdit ? selectedItem?.evmasterdata_id?.id : '',
              min_price_per_unit: isEdit ? selectedItem?.min_price_per_unit : '',
              discount_type: 'percentage',
              discount_value: isEdit ? selectedItem?.discount_value : '',
            }}
            validationSchema={ValidationSchema}
            onSubmit={async (values, { setSubmitting }) => {
              try {
                let lightImageUrl = '';
                let darkImageUrl = '';

                if (values.lightLogoFile) {
                  lightImageUrl = await handleImage(values.lightLogoFile);
                }

                if (values.darkLogoFile) {
                  darkImageUrl = await handleImage(values.darkLogoFile);
                }

                const payload = {
                  name: values.name,
                  light_logo_url: lightImageUrl || values.light_logo_url,
                  dark_logo_url: darkImageUrl || values.dark_logo_url,
                  evmasterdata_id: values.evmasterdata_id,
                  min_price_per_unit: values.min_price_per_unit,
                  discount_type: values.discount_type,
                  discount_value: values.discount_value,
                };

                if (isEdit) {
                  // Add id for update
                  payload.id = selectedItem.id;
                  await editCoCapex(payload);
                } else {
                  await addCoCapexItem(payload);
                }
              } catch (error) {
                toast.error(isEdit ? 'Error updating co-capex' : 'Error adding co-capex');
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({ values, errors, touched, handleSubmit, handleChange, setFieldValue, isSubmitting }) => (
              <Form onSubmit={handleSubmit}>
                <BootstrapForm.Group className="mb-3">
                  <BootstrapForm.Label className="text-white">Name</BootstrapForm.Label>
                  <TextInput
                    isRequired
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                    error={errors.name && touched.name ? errors.name : null}
                  />
                </BootstrapForm.Group>

                <BootstrapForm.Group className="mb-3">
                  <Select
                    isRequired
                    label={t('coCapex.evmaster_id')}
                    options={makeList.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }))}
                    placeholder={t('coCapex.evmaster_id')}
                    name="evmasterdata_id"
                    value={_.get(values, 'evmasterdata_id', '')}
                    onChange={(val) => {
                      setFieldValue('evmasterdata_id', val);
                    }}
                    error={getIn(errors, 'evmasterdata_id') && getIn(touched, 'evmasterdata_id') ? getIn(errors, 'evmasterdata_id') : null}
                  />
                </BootstrapForm.Group>

                <BootstrapForm.Group className="mb-3">
                  <BootstrapForm.Label className="text-white">Minimum Price Per Unit</BootstrapForm.Label>
                  <TextInput
                    isRequired
                    name="min_price_per_unit"
                    value={values.min_price_per_unit}
                    onChange={handleChange}
                    error={errors.min_price_per_unit && touched.min_price_per_unit ? errors.min_price_per_unit : null}
                  />
                </BootstrapForm.Group>

                <BootstrapForm.Group className="mb-3">
                  <BootstrapForm.Label className="text-white">Discount Value</BootstrapForm.Label>
                  <TextInput
                    isRequired
                    name="discount_value"
                    value={values.discount_value}
                    onChange={handleChange}
                    error={errors.discount_value && touched.discount_value ? errors.discount_value : null}
                  />
                </BootstrapForm.Group>

                <BootstrapForm.Group className="mb-3 text-white">
                  <BootstrapForm.Label>Light Logo</BootstrapForm.Label>
                  <div style={{ textAlign: 'center' }}>
                    <div
                      onClick={() => document.getElementById('lightLogo').click()}
                      onDrop={(e) => {
                        e.preventDefault();
                        const droppedFiles = e.dataTransfer.files;
                        if (droppedFiles.length > 0) {
                          const reader = new FileReader();
                          reader.onload = (event) => {
                            setShowLightIcon(event.target.result);
                            setFieldValue('lightLogoFile', droppedFiles[0]);
                          };
                          reader.readAsDataURL(droppedFiles[0]);
                        }
                      }}
                      onDragOver={(e) => e.preventDefault()}
                      style={{
                        display: 'block',
                        border: '2px dashed #ccc',
                        padding: '20px',
                        textAlign: 'center',
                        cursor: 'pointer',
                      }}
                    >
                      <input
                        type="file"
                        id="lightLogo"
                        accept=".png, image/png"
                        style={{ display: 'none' }}
                        onChange={(e) => {
                          const selectedFile = e.target.files[0];
                          if (selectedFile) {
                            const reader = new FileReader();
                            reader.onload = (event) => {
                              setShowLightIcon(event.target.result);
                              setFieldValue('lightLogoFile', selectedFile);
                            };
                            reader.readAsDataURL(selectedFile);
                          }
                        }}
                      />
                      <p>
                        {showLightIcon ? (
                          <img src={showLightIcon} alt="Light Logo" style={{ maxWidth: '100%', maxHeight: '200px', marginTop: '10px' }} />
                        ) : (
                          <div>
                            <FaCloudUploadAlt style={{ fontSize: '24px', marginBottom: '5px' }} />
                            <br />
                            {t('coCapex.light_image')}
                          </div>
                        )}
                      </p>
                    </div>
                    {getIn(errors, 'light_logo_url') && getIn(touched, 'light_logo_url') && (
                      <div className="text-danger mt-1 text-start">{getIn(errors, 'light_logo_url')}</div>
                    )}
                  </div>
                </BootstrapForm.Group>

                <BootstrapForm.Group className="mb-3 text-white">
                  <BootstrapForm.Label>Dark Logo</BootstrapForm.Label>
                  <div style={{ textAlign: 'center' }}>
                    <div
                      onClick={() => document.getElementById('darkLogo').click()}
                      onDrop={(e) => {
                        e.preventDefault();
                        const droppedFiles = e.dataTransfer.files;
                        if (droppedFiles.length > 0) {
                          const reader = new FileReader();
                          reader.onload = (event) => {
                            setShowDarkIcon(event.target.result);
                            setFieldValue('darkLogoFile', droppedFiles[0]);
                          };
                          reader.readAsDataURL(droppedFiles[0]);
                        }
                      }}
                      onDragOver={(e) => e.preventDefault()}
                      style={{
                        display: 'block',
                        border: '2px dashed #ccc',
                        padding: '20px',
                        textAlign: 'center',
                        cursor: 'pointer',
                      }}
                    >
                      <input
                        type="file"
                        id="darkLogo"
                        accept=".png, image/png"
                        style={{ display: 'none' }}
                        onChange={(e) => {
                          const selectedFile = e.target.files[0];
                          if (selectedFile) {
                            const reader = new FileReader();
                            reader.onload = (event) => {
                              setShowDarkIcon(event.target.result);
                              setFieldValue('darkLogoFile', selectedFile);
                            };
                            reader.readAsDataURL(selectedFile);
                          }
                        }}
                      />
                      <p>
                        {showDarkIcon ? (
                          <img src={showDarkIcon} alt="Dark Logo" style={{ maxWidth: '100%', maxHeight: '200px', marginTop: '10px' }} />
                        ) : (
                          <div>
                            <FaCloudUploadAlt style={{ fontSize: '24px', marginBottom: '5px' }} />
                            <br />
                            {t('coCapex.dark_image')}
                          </div>
                        )}
                      </p>
                    </div>
                    {getIn(errors, 'dark_logo_url') && getIn(touched, 'dark_logo_url') && (
                      <div className="text-danger mt-1 text-start">{getIn(errors, 'dark_logo_url')}</div>
                    )}
                  </div>
                </BootstrapForm.Group>

                <div className="d-flex justify-content-end gap-2">
                  <Button onClick={handleCloseModal}>Cancel</Button>
                  <Button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                    {isSubmitting ? 'Saving...' : 'Save'}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CoCapexList;
